/* eslint-disable @typescript-eslint/ban-ts-comment */
// @ts-nocheck

import { gsap } from 'gsap';
import {
    DoubleSide,
    Mesh,
    PlaneGeometry,
    type ShaderMaterial,
    type Texture,
    // BufferGeometry,
    // Float32BufferAttribute
} from 'three';

import { listen } from '@pkg/components/Sections/Profile/pubSub';
import { glUpdateTopic } from '@pkg/components/Sections/Profile/pubSub/constants';

import Material from './Material';

export default class LQBackground extends Mesh {
    private _noiseTexture!: Texture;
    isAnimating: boolean;

    constructor() {
        const material = new Material();
        material.side = DoubleSide;
        // const _geometry = new BufferGeometry();
        // _geometry.setAttribute('position', new Float32BufferAttribute([-1, 3, 0, -1, -1, 0, 3, -1, 0], 3));
        // _geometry.setAttribute('uv', new Float32BufferAttribute([0, 2, 0, 0, 2, 0], 2));
        // super(_geometry, material);
        super(new PlaneGeometry(10, 10.2), material);
        this.renderOrder = -10000;
        this.isAnimating = false;

        listen(glUpdateTopic, this.update.bind(this));
    }

    transitionIn(forceShow) {
        if (forceShow) {
            if (this.isAnimating) return;

            this.isAnimating = true;

            gsap.fromTo(
                this.material.uniforms.opacity,
                {
                    value: 0.0,
                },
                {
                    value: 1,
                    delay: 1.0,
                    duration: 1.0,
                },
            );
            gsap.fromTo(
                this.material.uniforms.strength,
                {
                    value: 0.0,
                },
                {
                    value: 3,
                    delay: 1.4,
                    duration: 2,
                    onComplete: () => {
                        this.isAnimating = false;
                    },
                },
            );
        } else {
            gsap.to(this.material.uniforms.strength, {
                value: 3,
                delay: 0.6,
                duration: 2,
            });
        }
    }
    transitionOut() {
        gsap.to(this.material.uniforms.strength, {
            value: 0,
            duration: 0.5,
        });
    }

    set noiseTexture(texture: Texture) {
        this._noiseTexture = texture;
        const material = this.material as ShaderMaterial;
        material.uniforms.noiseMap.value = this._noiseTexture;
    }

    update({ elapsed }) {
        const material = this.material as ShaderMaterial;
        material.uniforms.time.value = elapsed;
    }
}
